import { CSVError } from 'works/legacy/lib/csv-error';
import { OrganizationUnitType } from '@institutions/graphql';
import {
  FullValidationErrorFragment,
  FullValidationErrorFragmentType,
} from '@common/graphql/fragments';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ImportWorkersMutationCgResponse,
  ImportWorkersMutationVariables,
  ValidateWorkersImportMutationCgResponse,
  ValidateWorkersImportMutationVariables,
  WorkerImportQueryCgResponse,
  WorkerImportQueryVariables,
} from '@common/graphql/schema';

export const ImportWorkers: TypedDocumentNode<
  ImportWorkersMutationCgResponse,
  ImportWorkersMutationVariables
> = gql`
  mutation ImportWorkers($input: CreateWorkerImportInput!) {
    createWorkerImport(input: $input) {
      id
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export type ImportWorkerResponse = {
  createWorkerImport: {
    id: string | null;
    errors: FullValidationErrorFragmentType[] | null;
  };
};

export type ImportWorkerVariables = {
  input: {
    file: File;
    inviteUponCreation: boolean;
  };
};

// TODO(OnDemand): move it to queries folder
export const ImportWorkerProgressQuery: TypedDocumentNode<
  WorkerImportQueryCgResponse,
  WorkerImportQueryVariables
> = gql`
  query WorkerImport($id: ID!) {
    workerImport(id: $id) {
      id
      pending
      state
    }
  }
`;

export type ImportWorkerProgressResponse = {
  workerImport: {
    id: string;
    pending: boolean;
    state: string;
  };
};

export const ValidateWorkersImport: TypedDocumentNode<
  ValidateWorkersImportMutationCgResponse,
  ValidateWorkersImportMutationVariables
> = gql`
  mutation ValidateWorkersImport($input: ValidateWorkersImportInput!) {
    validateWorkersImport(input: $input) {
      workers {
        otherUnits {
          id
          name
          costCenter
        }
        email
        employeeId
        firstName
        ftePercentage
        lastName
        homeUnit {
          id
          name
          costCenter
        }
        phoneNumber
        role {
          id
          abbreviation
        }
        workforceGroup {
          id
          name
        }
      }
      errors {
        row
        type
        field
        message
      }
    }
  }
`;

export type ImportWorker = {
  otherUnits: [OrganizationUnitType];
  email: string;
  employeeId: string;
  firstName: string;
  ftePercentage: number | null;
  homeUnit: OrganizationUnitType;
  lastName: string;
  phone: string;
  role: { id: string };
  workforce_group: { id: string };
};

export type ValidateWorkersImportResponse = {
  validateWorkersImport: {
    workers: ImportWorker[];
    errors: CSVError[];
  };
};

export type ValidateWorkersImportVariables = {
  input: {
    file: File;
  };
};
